import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=c57127f0&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=ts&"
export * from "./Dashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57127f0",
  null
  
)

component.options.__file = "Dashboard.vue"
export default component.exports